import { useState } from "react";
import type { SignFolder } from "../types";
import { IcoClose, IcoFolder, IcoPlus } from "./icons";

export function MoveSheet({
  folders,
  currentId,
  busy = false,
  err = "",
  onPick,
  onCreate,
  onClose,
}: {
  folders: SignFolder[];
  currentId: number;
  busy?: boolean;
  err?: string;
  onPick: (folderId: number) => void;
  onCreate: (name: string) => void;
  onClose: () => void;
}) {
  const [fresh, setFresh] = useState("");
  const others = folders.filter((f) => f.id !== currentId);
  const canCreate = fresh.trim().length >= 2 && !busy;

  function create() {
    if (!canCreate) return;
    onCreate(fresh.trim());
  }

  return (
    <div className="sg-send-back" role="dialog" aria-label="Déplacer le document">
      <div className="sg-send">
        <h2>Déplacer vers</h2>
        {others.length === 0 ? (
          <p className="sg-legal">Aucun autre dossier. Créez-en un ci-dessous.</p>
        ) : (
          <div className="sg-move-list">
            {others.map((f) => (
              <button key={f.id} type="button" className="sg-btn ghost" disabled={busy} onClick={() => onPick(f.id)}>
                <IcoFolder />
                {f.name}
              </button>
            ))}
          </div>
        )}
        <label>
          Nouveau dossier
          <input
            className="sg-input"
            value={fresh}
            disabled={busy}
            placeholder="Compta, Clients, CDI 35H…"
            onChange={(e) => setFresh(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && create()}
          />
        </label>
        {err ? <p className="sg-err">{err}</p> : null}
        <div className="sg-send__actions">
          <button type="button" className="sg-btn ghost" disabled={busy} onClick={onClose}>
            <IcoClose />
            Annuler
          </button>
          <button type="button" className="sg-btn" disabled={!canCreate} onClick={create}>
            <IcoPlus />
            {busy ? "Création…" : "Créer et y déplacer"}
          </button>
        </div>
      </div>
    </div>
  );
}
